<template>
    <div>
        <buttonlist ref="SetBtn" @exps="exps" @help="help"></buttonlist>
        <div style="width:100%">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[112]') }}</td>
                    <td style="width:200px;">
                        <routejump :urlNo="12">
                        <el-input  type="text" v-model="dataDetail.partcode"
                                   readonly
                                   class="mcolor"
                                   size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpart()"></i>
                        </el-input>
                        </routejump>
                    </td>
                    <td style="width:60px">{{ $t('getapi[149]') }}</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="dataDetail.partversion" :disabled="true"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[827]') }}</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="dataDetail.item_code" :disabled="true"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[2573]') }}</td>
                    <td style="width:150px;">
                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.invqty" :disabled="true"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[157]') }}</td>
                    <td style="width:150px;">
                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.safeinventory" :disabled="true"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[7190]') }}</td>
                    <td style="width:150px;">
                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.saledemand" :disabled="true"></el-input>
                    </td>
                    <td>
                        <el-checkbox v-model="dataDetail.saledemandflag" true-label="是" false-label="否"  :disabled="true">{{ $t('getapi[7191]') }}</el-checkbox>
                    </td>
                </tr>
            </table>
            <el-table
                    id="xpane-0"
                    :data="dataDetail.Lists"
                    ref="singleTable"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column type="selection" v-if="false"></el-table-column>
                <el-table-column show-overflow-tooltip prop="riqi" :label="$t('getapi[6367]')"></el-table-column>
                <el-table-column prop="supply" :label="$t('getapi[7192]')" align="right">
                    <template slot-scope="scope">
                        {{scope.row.supply | thousandth}}
                    </template>
                </el-table-column>
                <el-table-column prop="demand" :label="$t('getapi[7193]')" align="right">
                    <template slot-scope="scope">
                        {{scope.row.demand | thousandth}}
                    </template>
                </el-table-column>
                <el-table-column prop="remain" :label="$t('getapi[7194]')" align="right">
                    <template slot-scope="scope">
                        {{scope.row.remain | thousandth}}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="sr_flag" :label="$t('getapi[2285]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="sr_flag_name" :label="$t('getapi[7195]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[2203]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="partversion" :label="$t('getapi[113]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="so_remark" :label="$t('getapi[12664]')"></el-table-column>
            </el-table>
        </div>
        <!--选择物料-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/MRP/CountView/GetMainPartPopupList'" @callback="getpart" ref="part"></selector>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_mainsupply',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight-180,
                    maxHeight: this.$windowSize.tableHeight-180,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                tableHeader: [],
                dataDetail: {
                    invqty: '',
                    safeinventory: '',
                    item_code: '',
                    partcode: '',
                    partversion: '',
                    saledemand: '',
                    saledemandflag: '',
                    Lists: [],
                    SchModel:{}
                },
                ABCarr: [],
                scrollTop:0,
            };
        },
        beforeRouteEnter(to, form, next) {            
            next(vm => {
                if(form!=null){
                    
                    if (form.name == '2_supplydemandinfo' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                        const data = {...vm.$store.state.sharedParams};
                        vm.dataDetail.item_code = data.item_code;
                        vm.dataDetail.partcode = data.part_code;
                        vm.dataDetail.partversion = data.part_version;                   
                        vm.dataDetail.invqty = data.invqty;
                        vm.dataDetail.safeinventory = data.safeinventory; 
                        vm.dataDetail.saledemandflag = data.saledemandflag;
                        let parm = {
                            part_code: data.part_code,
                            part_version: data.part_version
                        }                        
                        vm.getDetail(parm);
                        vm.$store.commit('clearSharedParams')
                    }
                }
            });
        },
        watch: {
            'dataDetail.Lists': function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
            that.colsort();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6602]"),'MRP');
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('export');
            },
            selectpart(row){
                let that = this;
                that.$refs.part.clearInput(true);
            },
            getpart(data){
                let that = this
                // console.log("选择数据:"+JSON.stringify( data))
                that.dataDetail.item_code = data.item_code
                that.dataDetail.partcode = data.partcode
                that.dataDetail.partversion = data.partversion
                that.dataDetail.products = data.products
                that.dataDetail.saledemandflag=data.saledemandflag
                let parm = {
                    part_code: data.partcode,
                    part_version: data.partversion
                }
                that.getDetail(parm)
            },
            getDetail(parm){
                let that = this
                that.$http.urlpost('/MRP/CountView/GetMainSupplyDemandInfo', parm, function (res) {
                    if (res.Success == 1) {
                        let data = res.DataContent;
                        that.dataDetail.invqty = data.invqty
                        that.dataDetail.safeinventory = data.safeinventory
                        that.dataDetail.saledemand = data.saledemand
                        that.dataDetail.Lists = data.Lists
                        that.dataDetail.SchModel = data.SchModel
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            exps(){
                let that = this
                let parm = {}
                that.$http.urlpost('/MRP/CountView/MainSupplyDemandToExcel', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
